import { CoreQuery } from '@/common/services/core-query';
import { EntitiesList } from '@/common/models';
import { authorizeClient, httpClientCoreQuery } from '@/api/http-client';
import { RuleDefinition, Rule, GetRuleParametersResponse, mapParameters, UnmappedParameter } from '../models';
import { FluentFilterCollection, Operator } from '@/common/services';
import { PaginatedDataUnmapped } from '@/common/models/paginated-data';

import { extractAxiosData } from '@/common/services/extractAxiosData';
import { RulesApiFactory as RulesApiFactoryV2 } from '@eloomi/eloomi-user-groups-persona-client/2.0';
import { AxiosResponse } from 'axios';

const rulesClientV2 = authorizeClient(RulesApiFactoryV2);

export function getRuleParameters(): Promise<GetRuleParametersResponse> {
    return rulesClientV2
        .getRuleParameters()
        .then(response => extractAxiosData<UnmappedParameter[]>(response as AxiosResponse))
        .then(mapParameters);
}

export function putRule(groupId: number, rule: RuleDefinition, ruleId: number | null = null) {
    const q = new CoreQuery().entity([EntitiesList.USER_GROUPS, EntitiesList.PERSONA, EntitiesList.RULE]);

    const payload = {
        ...(ruleId !== null ? { id: ruleId } : {}),
        user_group_id: groupId,
        definition: rule,
    };

    return httpClientCoreQuery.put(q, payload);
}

export function getRuleById(ruleId: number) {
    const q = new CoreQuery().entity([EntitiesList.USER_GROUPS, EntitiesList.PERSONA, EntitiesList.RULE, ruleId]);

    return httpClientCoreQuery.get<Rule>(q).then(({ data }) => data);
}

export function getRules(
    options: { page: number; pageSize: number },
    groupId: number
): Promise<PaginatedDataUnmapped<Rule>> {
    const filters = new FluentFilterCollection().where('user_group_id').filter(Operator.IsEqualTo, groupId);

    const q = new CoreQuery()
        .entity([EntitiesList.USER_GROUPS, EntitiesList.PERSONA, EntitiesList.RULE, EntitiesList.GROUP, groupId])
        .filters(filters)
        .param({
            page: options.page,
            page_size: options.pageSize,
        });

    return httpClientCoreQuery.get<PaginatedDataUnmapped<Rule>>(q).then(({ data }) => data);
}

export function previewUserCount(rule: RuleDefinition) {
    const q = new CoreQuery().entity([
        EntitiesList.USER_GROUPS,
        EntitiesList.PERSONA,
        EntitiesList.RULE,
        EntitiesList.PREVIEW,
    ]);

    return httpClientCoreQuery.post<number>(q, rule).then(({ data }) => data);
}

export function deleteRules(ruleIds: Array<number>) {
    const q = new CoreQuery()
        .entity([EntitiesList.USER_GROUPS, EntitiesList.PERSONA, EntitiesList.RULE])
        .data({ ids: ruleIds });

    return httpClientCoreQuery.delete<''>(q).then(({ data }) => data);
}
